import React from "react";
import { useNavigate, useParams } from "react-router";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "./components/Breadcrumb/Breadcrumb";
import Sidebar from "./components/Sidebar/Sidebar";
import SchemesContent from "./components/SchemesContent/SchemesContent";
import schemeMenuItems, { normalizeSchemeSection } from "./data/schemeMenuItems";

const SchemesPage = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const activeSection = normalizeSchemeSection(section);

  useFocusPageStart(section || activeSection);

  const handleSelectSection = (sectionId) => {
    navigate(`/schemes/${sectionId}`);
  };

  const currentSection =
    schemeMenuItems.find((item) => item.id === activeSection) ||
    schemeMenuItems[0];

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Schemes", path: "/schemes" },
    { label: currentSection.label, path: `/schemes/${activeSection}` },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-4 pt-2 pb-3 md:px-20 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 outline-none"
      >
        <div className="px-4 pt-7 pb-3.5 md:px-20 md:pb-[18px]">
          <h1 className="m-0 text-[20px] font-bold leading-[1.2] uppercase tracking-[1px] text-[#1b3a6b] md:text-[23px] first-letter:text-[#ff9933]">
            {currentSection.label}
          </h1>
        </div>

        <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-5 p-5 md:p-10 lg:flex-row lg:gap-[30px]">
          <Sidebar
            activeSection={activeSection}
            onSelectSection={handleSelectSection}
            menuItems={schemeMenuItems}
          />
          <SchemesContent activeSection={activeSection} />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SchemesPage;
